<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="lab">
      <div class="lab-inner">
        <div v-loading="loading">
          <div class="bar flex flex-row flex-between">
            <SearchBar
              :num="totalItem"
              v-model="searchKey"
              @btnClick="searchBarClick"
            />
            <el-button
              type="text"
              icon="el-icon-location"
              size="medium"
              @click="nearbyLabClick"
              >我附近的实验室</el-button
            >
          </div>
          <div class="lists">
            <LabItem v-for="(item, index) in lists" :key="index" :data="item" />
          </div>
        </div>
        <HotLab />
      </div>
      <!-- 分页-->
      <Pagination
        :total="totalItem"
        :page="page"
        @pageIndexChange="handlePageChange"
      />
    </div>

    <FootBar class="footer" />
  </div>
</template>
<script>
import { labList } from "@/api/lab";
import SearchBar from "./components/SearchBar";
import Pagination from "@/components/Pagination/index";
import HotLab from "./components/HotLab.vue";
import LabItem from "./components/LabItem.vue";
export default {
  components: {
    Pagination,
    HotLab,
    SearchBar,
    LabItem,
  },
  data() {
    return {
      totalItem: 0,
      lists: [],
      page: {
        pageIndex: 1,
        pageSize: 9,
      },
      searchKey: "",
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    searchBarClick() {
      this.page.pageIndex = 1;
      this.getList();
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const { list, totalItem } = await this.$axios
        .post(labList, {
          ...this.page,
          key: this.searchKey,
        })
        .finally(() => {
          this.loading = false;
        });
      this.lists = list;
      this.totalItem = totalItem;
    },
    toDetail({ laboratoryId }) {
      this.$jump.push({ name: "labDetail", query: { id: laboratoryId } });
    },
    // 跳转到附近的实验室页面
    nearbyLabClick() {
      this.$jump.push({ name: "labNearby" });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
$item-h: 120px;
.lab {
  background: #f7f7f7;
  padding-bottom: 20px;
  padding-top: 33px;
  &-inner {
    display: grid;
    grid-template-columns: calc(100% - 280px) 280px;
    gap: 20px;
    width: $max-width;
    margin: 0 auto;
    min-height: 400px;
    margin-bottom: 20px;
    ::v-deep .el-button--text {
      color: #ff9531;
      .el-icon-location {
        font-size: 20px;
      }
    }
  }
}
.bar {
  padding: 15px;
  margin-bottom: 15px;
}
.hot {
  width: 340px;
  margin-left: 20px;
}
.lists {
  display: grid;
  grid-template-columns: repeat(3, calc(33.333333% - 13px));
  gap: 20px;
}
</style>
